import BaseApiService from "../base_api.service";
import { CreateUpdateMenuProductDto } from "./models/create_update_menu_product.dto";
import { GetMenuProductByIdResponse } from "./models/get_menu_product_by_id.response";
import { GetMenuProductListResponseModel } from "./models/get_menu_product_list.response";
import { MenuProductDto } from "./models/menu_product.dto";
import { MenuProductModel } from "./models/menu_product.model";

class MenuProductServcie extends BaseApiService {
  constructor() {
    super("MenuProducts");
  }
  async getList(companyId: string): Promise<MenuProductModel[]> {
    return (await this.get(`?companyId=${companyId}`)) ?? [];
  }
  async getDtoList(companyId: string): Promise<MenuProductDto[]> {
    return (await this.get(`GetDtoList?companyId=${companyId}`)) ?? [];
  }
  async getListByStatus(
    companyId: string,
    status: boolean = true,
  ): Promise<GetMenuProductListResponseModel[]> {
    return (
      (await this.get(
        `/GetListByStatus?companyId=${companyId}&status=${status}`,
      )) ?? []
    );
  }
  add(
    menuProductModel: CreateUpdateMenuProductDto,
  ): Promise<MenuProductModel | undefined> {
    return this.post<MenuProductModel>(``, {
      ...menuProductModel,
      id: menuProductModel.id == "" ? null : menuProductModel.id,
      printerId:
        menuProductModel.printerId == "" ? null : menuProductModel.printerId,
    });
  }
  getById(id: string): Promise<GetMenuProductByIdResponse | undefined> {
    return this.get<GetMenuProductByIdResponse>(`/${id}`);
  }
  update(
    menuProductModel: CreateUpdateMenuProductDto,
  ): Promise<MenuProductModel | undefined> {
    return this.put<MenuProductModel>(``, {
      ...menuProductModel,
      printerId:
        menuProductModel.printerId == "" ? null : menuProductModel.printerId,
    });
  }
  deleteProduct(id: string): Promise<string | undefined> {
    return this.delete<string>(`?id=${id}`);
  }
}
export default MenuProductServcie;
